export default "__VITE_ASSET__CWzHX1Fg__"